<template>
	<div class="users">
		<ul class="users__list" :id="uid">
			<li
				:id="`${uid}_${index}`"
				class="users__item"
				v-for="(user, index) in items"
				:key="index"
			>
				<UserCard :id="`${uid}_${index}_card`" :user="user" />
			</li>
		</ul>
	</div>
</template>

<script>
import UserCard from './users-card';

export default {
	name: 'UserList',

	components: {
		UserCard
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Users Results List
    * Can use SCSS variables = TRUE
		* [Table of Contents]
    *
    * BASE
*/

/*------------------------------------*\
  #BASE
\*------------------------------------*/

.users {
	&__list {
		display: grid;
		grid-template-columns: 1fr;
		gap: $gutter-lg;

		@include mq($from: lg) {
			grid-template-columns: 1fr 1fr;
		}
	}
}
</style>
